import {
	ImageURISource,
	StyleSheet,
	TouchableOpacity,
	TouchableOpacityProps,
	View,
} from 'react-native';
import { Text } from '@ui-kitten/components';

import { Badge } from '../Badge';
import { UserAvatar } from '../UserAvatar';

export const UserInfo = ({
	id,
	name = '',
	email = '',
	photoSource,
	bolded = false,
	badge = false,
	onPress,
	userCount = 0,
	isPremium = false,
	size = 40,
	style,
	...touchableProps
}: Props) => {
	return (
		<TouchableOpacity onPress={onPress} style={[styles.root, style]} {...touchableProps}>
			<Badge invisible={!badge}>
				<UserAvatar
					size={size}
					username={name}
					source={photoSource}
					isPremium={isPremium}
					userCount={userCount}
				/>
			</Badge>
			<View style={styles.info}>
				<Text category={bolded ? 'h5' : 'h6'} numberOfLines={2}>
					{name}
				</Text>
				{!!email && (
					<Text category="s2" appearance={badge ? 'default' : 'hint'} numberOfLines={2}>
						{email}
					</Text>
				)}
			</View>
		</TouchableOpacity>
	);
};

const styles = StyleSheet.create({
	root: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		flex: 1,
	},
	info: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		marginLeft: 8,
	},
});

type Props = {
	id?: string;
	name?: string;
	email?: string;
	photoSource?: ImageURISource;
	bolded?: boolean;
	badge?: boolean;
	userCount?: number;
	size?: number;
	isPremium?: boolean;
} & TouchableOpacityProps;
